import { Link } from "react-router-dom";
import VerticalTextCarousel from "../Components/Home.component/VerticalTextCarousel";
import HomeCarouselComp from "../Components/Home.component/HomeCarouselImages";
import Aos from "aos";
import GalleryView from "../Components/Home.component/HomePageGallery";
import NewsAnnoucementText from "../Components/Home.component/Card.component/NewsAnnouncement";
import NoticeBoardText from "../Components/Home.component/Card.component/NoticeBoard";
import UpcomingEvents from "../Components/Home.component/Card.component/UpcomingEvents";
import { Grid } from "@mui/material";
import TransitionsModal from "../Components/ReusableComponent/Modal";
// import admissionmodalpopupimage from "../assets/images/MBA_BBA_POPUP.jpg";
// import admissionmodalpopupimage from "../assets/images/HomeDesk/Admission Open 2025.jpg";
// import admissionmodalpopupimage2026 from "../assets/images/HomeDesk/Admission Open 2026.jpg";
import admissionmodalpopupimage2026_27 from "../assets/images/HomeDesk/MIBM WEBSITE POP-UP2026_27.png";

import { useState } from "react";
import AdmissionModal from "../Components/AdmissionModal";
import video from "../assets/video/HOME/VN20250804_135352.mp4";
import VideoCard from "../Components/ReusableComponent/VideoHome";
import WhatsAppButton from "../Components/Home.component/WhatsAppButton";
import Marquee from "react-fast-marquee";
import { Box, Typography } from "@mui/material";
import { keyframes } from "@mui/system";
import FRA2526 from "../assets/pdf/NoticeBoard/FRAOnline2526.pdf";
import { AcademicExcellence } from "../Components/Home.component/AcademicExcellence";
import { FuturePrograms } from "../Components/Home.component/FutureProgram";
import { AllEventsSection } from "./ViewMorePages/AllEventsSection";

Aos.init({
  duration: 1000,
});

const Home = () => {
  const [open, setOpen] = useState(true);
  const scrollUp = keyframes`
  0% { transform: translateY(0%); }
  100% { transform: translateY(-50%); } 
`;

  const announcements = [
    {
      text: (
        <>
          Visit{" "}
          <a
            href="https://cetcell.mahacet.org"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#1976d2",
              textDecoration: "underline",
            }}
          >
            cetcell.mahacet.org
          </a>{" "}
          for further details related to common entrance
        </>
      ),
    },
    {
      text: (
        <Link
          component="button"
          onClick={() => setOpen(true)}
          underline="hover"
          sx={{ color: "primary.main" }}
        >
          Admissions Open
        </Link>
      ),
    },
    {
      text: (
        <a
          href={
            process.env.PUBLIC_URL +
            "/assets/pdf/NoticeB/FRA Proposal for A. Y. (2026-27).pdf"
          }
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          FRA FEES Proposal for A. Y. 2026-27
        </a>
      ),
    },

    // {
    //   text: (
    //     <a
    //       href="https://forms.gle/M8PsQwD9G8fFMmUY6"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{
    //         color: "#1976d2",
    //         textDecoration: "underline",
    //       }}
    //     >
    //       Application for MBA Lateral Entry Admissions
    //     </a>
    //   ),
    // },
    {
      text: (
        <a
          href="https://mibm.vriddhionline.com/Login_1StudLogin_OCMS2.aspx"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          Vruddhi Admission Portal
        </a>
      ),
    },
    // {
    //   text: (
    //     <a
    //       href="https://drive.google.com/file/d/1Jr_CHCBuQRKYxdJVNyNAJoauDx8Qe-4o/view?usp=sharing"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{
    //         color: "#1976d2",
    //         textDecoration: "underline",
    //       }}
    //     >
    //       Institute level and Against CAP Vacancy
    //     </a>
    //   ),
    // },
    // {
    //   text: (
    //     <a
    //       href="https://drive.google.com/file/d/18Waip-4F0vbe0lToDy3An5_ejYguUMua/view?usp=sharing"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{
    //         color: "#1976d2",
    //         textDecoration: "underline",
    //       }}
    //     >
    //       Institute Level/Against Cap Round Notice
    //     </a>
    //   ),
    // },
    // {
    //   text: (
    //     <a
    //       href="https://drive.google.com/file/d/1IPTLEMpYNsE6N1syROS-JvLEHmzrDyOc/view?usp=sharing"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{
    //         color: "#1976d2",
    //         textDecoration: "underline",
    //       }}
    //     >
    //       BBA Against Cap Merit List 2025
    //     </a>
    //   ),
    // },
    // {
    //   text: (
    //     <a
    //       href="https://drive.google.com/file/d/1HXO7Wcpdo_CmOZqwxBfZPw-Ir1978NhA/view?usp=sharing"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{
    //         color: "#1976d2",
    //         textDecoration: "underline",
    //       }}
    //     >
    //       BBA Merit List IL 2025
    //     </a>
    //   ),
    // },
    // {
    //   text: (
    //     <a
    //       href="https://drive.google.com/file/d/1mVpwQ5bRA8CrTl8zvIq0GJL5aEhuEKBg/view?usp=sharing"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{
    //         color: "#1976d2",
    //         textDecoration: "underline",
    //       }}
    //     >
    //       Institute level Final Merit List
    //     </a>
    //   ),
    // },
    // {
    //   text: (
    //     <a
    //       href="https://drive.google.com/file/d/1SuMvsqI5AxnHNXoNCarrIuWXgsyl9Uwb/view?usp=sharing"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{
    //         color: "#1976d2",
    //         textDecoration: "underline",
    //       }}
    //     >
    //       MBA Institute level Final Merit List
    //     </a>
    //   ),
    // },
    // {
    //   text: (
    //     <a
    //       href="https://drive.google.com/file/d/1eaYyvbHGQa5FQZIBOlVhkEoRkJinydSr/view?usp=sharing"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{
    //         color: "#1976d2",
    //         textDecoration: "underline",
    //       }}
    //     >
    //       MBA Against CAP Final Merit List
    //     </a>
    //   ),
    // },
    // {
    //   text: (
    //     <a
    //       href="https://drive.google.com/file/d/13yOaT7RM5-bv_bYGWaUnkC_aLzoSWg2B/view?usp=sharing"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{
    //         color: "#1976d2",
    //         textDecoration: "underline",
    //       }}
    //     >
    //       BBA IL/ACAP Admission Notice
    //     </a>
    //   ),
    // },
    // {
    //   text: (
    //     <a
    //       href="https://forms.gle/7qiRfDLiR4UAE9s29"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{
    //         color: "#1976d2",
    //         textDecoration: "underline",
    //       }}
    //     >
    //       BBA IL/ACAP Application Form
    //     </a>
    //   ),
    // },
    // {
    //   text: (
    //     <a
    //       href="https://drive.google.com/file/d/1Wl4ZiC2LcodApIzSYYnyTPCjUyOw2LTm/view?usp=sharing"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{
    //         color: "#1976d2",
    //         textDecoration: "underline",
    //       }}
    //     >
    //       BBA IL/ACAP Vacancy
    //     </a>
    //   ),
    // },
    {
      text: (
        <a
          // href="https://drive.google.com/file/d/1hLalIbjMtINwTX7wnD04e6Vg0ffV-t6F/view?usp=sharing"
          // href="https://drive.google.com/file/d/1shXI3gwpdFjoDFlIlQPn2pk37l90w5NJ/view?usp=drive_link"
          href="https://drive.google.com/file/d/1dbQvFRURJhyS244xy91naeTksd5uCzOk/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          BBA IL & ACAP{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>NOTICE</span>
        </a>
      ),
    },
    {
      text: (
        <a
          // href="https://drive.google.com/file/d/185SeY59yrJGjBt7xDV9Kr9sxoCLB893s/view?usp=drive_link"
          // href="https://drive.google.com/file/d/1vVrsFGB2eJjLz2SI0lmtYmuiRJaLqMAC/view?usp=drive_link"
          href="https://drive.google.com/file/d/1DuF8HtwLPKieXiIj8-xrHBSf_oxIUsnR/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          MBA IL & ACAP{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>NOTICE</span>
        </a>
      ),
    },
    {
      text: (
        <a
          // href="https://drive.google.com/file/d/1q-tS5JdUMbhXo90xXtSYupNyj_AlAECh/view?usp=sharing"
          // href="https://drive.google.com/file/d/1q-tS5JdUMbhXo90xXtSYupNyj_AlAECh/view?usp=sharing"
          href="https://drive.google.com/file/d/1F8RFHZoq7jEb35yhunHDFWeUx2Hhql3y/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          LATERAL ADMISSION ADVERTISMENT
        </a>
      ),
    },
    {
      text: (
        <a
          // href="https://drive.google.com/file/d/1q-tS5JdUMbhXo90xXtSYupNyj_AlAECh/view?usp=sharing"
          href="https://forms.gle/B41d2QxeaTz1JBVDA"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          {/* LATERAL ADVERTISMENT */}
          Institute Level/Against Cap Round Application Form
        </a>
      ),
    },

    {
      text: (
        <a
          // href="https://drive.google.com/file/d/1B46z3BVcO9DdyzV_rnVhdjmaFlP8qyp1/view?usp=drive_link"
          href="https://drive.google.com/file/d/1nw1YWzlLl3V9u6U0Cqzt4EZep-8p7SaU/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          Lateral Admission Merit List{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>Final</span>
        </a>
      ),
    },
    {
      text: (
        <a
          href="https://drive.google.com/file/d/1mkdfoK7Gc4pvKIER5oSACj3NZLVIfDfb/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          Lateral Admission Merit List{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>
            Provisional
          </span>
        </a>
      ),
    },
    {
      text: (
        <a
          href="https://drive.google.com/file/d/1wgbRjvsGU7F38mlg75dfUxiTyHGvpkqO/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          LATERAL ADMISSION{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>Notice</span>
        </a>
      ),
    },
    {
      text: (
        <a
          href="https://drive.google.com/file/d/1KZUCyWLKgPGU-1fPWs7RYT_wVyIN5pUY/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          BBA ACAP FINAL MERIT LIST{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>
            A.Y. 2026-27
          </span>
        </a>
      ),
    },
    {
      text: (
        <a
          href="https://drive.google.com/file/d/1whDUGM_4BZ996FtNsr8C92Ka7Zk-39CM/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          BBA IL FINAL MERIT LIST{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>
            A.Y. 2026-27
          </span>
        </a>
      ),
    },
    {
      text: (
        <a
          href="https://drive.google.com/file/d/1ck8fZuDgz9PhCq0_R1iUCKwYN0qc2so4/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          MBA IL FINAL MERIT LIST{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>
            A.Y. 2026-27
          </span>
        </a>
      ),
    },
    {
      text: (
        <a
          href="https://drive.google.com/file/d/1mygvnvZR3RC6xEe3WkMqSFX5mPtMPj5g/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          MBA ACAP FINAL MERIT LIST{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>
            A.Y. 2026-27
          </span>
        </a>
      ),
    },
    {
      text: (
        <a
          // href="https://drive.google.com/file/d/1dg6zkh6K9ervP7M6wFcTFks8eWpooLdq/view?usp=sharing"
          href="https://drive.google.com/file/d/19V8VctPvUU4XYzMvcZQ_FaHKAT-SU-jw/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          Vacancy Positions for MBA Direct Second Year (Lateral Entry) A.Y.
          2026–2027
        </a>
      ),
    },
    {
      text: (
        <a
          // href="https://drive.google.com/file/d/19A4DP62_r8EMp85yt3806Gdt8nmRXAvf/view?usp=drive_link"
          href="https://drive.google.com/file/d/1Xvyb4Aqnl9SFljLwCwcMrjIPGjxvmOg-/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          BBA INSTITUTE LEVEL PROVISIONAL MERIT LIST{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>
            A.Y. 2026-27
          </span>
        </a>
      ),
    },
    {
      text: (
        <a
          // href="https://drive.google.com/file/d/15XT5VpujgD_S5GNce-ZW0wioMenH4SF7/view?usp=drive_link"
          href="https://drive.google.com/file/d/1L_3LTw9Znxykym_tIWcC6jlsquRcsrDC/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          BBA AGAINST CAP PROVISIONAL MERIT LIST{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>
            A.Y. 2026-27
          </span>
        </a>
      ),
    },
    {
      text: (
        <a
          href="https://drive.google.com/file/d/1lMS46Q2tg1JOiX_4Fzcca8OZGE8ZhZ2c/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          MBA INSTITUTE LEVEL PROVISIONAL MERIT LIST{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>
            A.Y. 2026-27
          </span>
        </a>
      ),
    },
    {
      text: (
        <a
          href="https://drive.google.com/file/d/1EkJ0z7dpcGOoZ2h5UWxAt97GckJEFuHl/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          MBA AGAINST CAP PROVISIONAL MERIT LIST{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>
            A.Y. 2026-27
          </span>
        </a>
      ),
    },
    {
      text: (
        <a
          href="https://drive.google.com/file/d/1YXfKeMkbJFomdMO9jUlTax2nm5nvwCjt/view?usp=drive_link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1976d2",
            textDecoration: "underline",
          }}
        >
          BBA & MBA IL and ACAP ADVERTISEMENT{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>
            A.Y. 2026-27
          </span>
        </a>
      ),
    },
    // {
    //   text: (
    //     <a
    //       href="https://drive.google.com/file/d/11t2ftguMV8xTs0bzlPgDa9NUS2m9ak1P/view?usp=sharing"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{
    //         color: "#1976d2",
    //         textDecoration: "underline",
    //       }}
    //     >
    //       MBA ADMISSION AGAINST CAP MERIT LIST 2025-2026
    //     </a>
    //   ),
    // },
    // {
    //   text: (
    //     <a
    //       href="https://drive.google.com/file/d/1wh22VMGQXWoik772Cantq_gt57NuH35U/view?usp=sharing"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{
    //         color: "#1976d2",
    //         textDecoration: "underline",
    //       }}
    //     >
    //       MBA Admission Institute Level Merit List 2025-2026
    //     </a>
    //   ),
    // },
    // {
    //   text: (
    //     <a
    //       href="https://drive.google.com/file/d/1Hf2uZgqZgy4evajsftQJziIc41o3gPp5/view?usp=drive_link"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{
    //         color: "#1976d2",
    //         textDecoration: "underline",
    //       }}
    //     >
    //       Public Notice Institute_Option_Form
    //     </a>
    //   ),
    // },
  ];

  const doubledAnnouncements = [...announcements, ...announcements];

  return (
    <>
      {/* <TransitionsModal /> */}
      {/*  - 10-07-2025 */}
      {/* <div className="backgroundImg pt-3 pb-3">
     //Image carousel & Desk
        <Grid container className="px-5 my-3">
          <Grid md={8} xs={12} className="px-3" data-aos="fade-right">
            <HomeCarouselComp />
          </Grid>
          <Grid md={4} xs={12} className="px-3" data-aos="fade-left">
            <VerticalTextCarousel />
          </Grid>
        </Grid>
      </div> */}

      {/* new */}
      {/* <div className="backgroundImg pt-3 pb-3">
        <div className="px-5 my-3 d-flex justify-content-center">
          <div
            // className="carousel-wrapper"
            data-aos="fade-right"
            style={{ width: "100%", maxWidth: "900px" }}
          >
            <HomeCarouselComp />
          </div>
        </div>
      </div> */}

      {/* <div className="backgroundImg pt-3 pb-3 d-flex justify-content-center">
          <VideoCard video={video} />
          <div className="m-auto">
            hduwdn
          </div>
        </div> */}

      <Box
        className="backgroundImg"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" }, // mobile = column, pc = row
          justifyContent: "center",
          gap: "16px",
          pt: "12px",
          pb: "12px",
          px: "12px",
        }}
      >
        {/* Video Section */}
        <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <VideoCard video={video} />
        </Box>

        {/* Notice Board Card */}
        <Box
          sx={{
            flex: 1,
            maxWidth: { xs: "100%", md: "350px" },
            backgroundColor: "#fff",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            border: "1px solid #e5e7eb",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              background: "#a70606",
              color: "#fff",
              py: "8px",
              px: "16px",
            }}
          >
            <Typography variant="subtitle1" color={"white"} fontWeight="bold">
              Latest Announcements
            </Typography>
          </Box>

          {/* Scroll Section */}
          <Box
            sx={{
              position: "relative",
              overflow: "hidden",
              height: "400px",
              "&:hover .scrollUp": {
                animationPlayState: "paused",
              },
            }}
          >
            <Box
              className="scrollUp"
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "40px",
                p: "8px",
                // animation: "scrollUp 10s linear infinite",
                animation: `${scrollUp} 15s linear infinite`,
              }}
            >
              {/* Original List */}
              {doubledAnnouncements.map((item, i) => (
                <Box className="announcementItem" key={i}>
                  <b style={{ fontSize: "18px" }}>{item.text}</b>
                </Box>
              ))}

              {/* Duplicate list for seamless loop */}
              {/* {announcements.map((item, i) => (
                <Box className="announcementItem" key={`dup-${i}`}>
                  <b style={{ fontSize: "18px" }}>{item.text}</b>
                </Box>
              ))} */}
            </Box>

            {/* Keyframes */}
            {/* <style>
              {`
          @keyframes scrollUp {
            0% { transform: translateY(0); }
            100% { transform: translateY(-50%); } 
          }
          .announcementItem {
            background: #f9fafb;
            border-radius: 6px;
            padding: 8px;
            transition: background 0.3s;
          }
          .announcementItem:hover {
            background: #eff6ff;
          }
        `}
            </style> */}
          </Box>
        </Box>
      </Box>

      <Grid
        md={4}
        xs={12}
        className="px-3"
        data-aos="fade-left"
        sx={{ my: 4, mb: 15 }}
      >
        <AcademicExcellence />
      </Grid>

      <Grid
        md={4}
        xs={12}
        className="px-3"
        data-aos="fade-left"
        sx={{ my: 4, mb: 15 }}
      >
        <FuturePrograms />
      </Grid>

      <Grid
        md={4}
        xs={12}
        className="px-3"
        data-aos="fade-left"
        sx={{ my: 4, mb: 15 }}
      >
        <VerticalTextCarousel />
      </Grid>

      <AllEventsSection />
      <div className="mt-5">
        <GalleryView />
      </div>
      <AdmissionModal
        open={open}
        setOpen={setOpen}
        src={admissionmodalpopupimage2026_27}
      />
      <div className="fixed">
        <WhatsAppButton />
      </div>
    </>
  );
};

export default Home;
